import { CartLine, Product } from './types';

export const snapToMultiple = (
  next: number,
  moq: number
): { qty: number; snapped: boolean } => {
  const m = Math.max(moq, 1);
  const qty = Math.max(m, Math.round(next / m) * m);
  return { qty, snapped: qty !== next };
};

// Largest MOQ multiple that fits in stock (min one MOQ — below that the
// sold-out path governs). Keeps stock-capped quantities honest multiples.
export const maxOrderableQty = (stock: number, moq: number): number => {
  const m = Math.max(moq, 1);
  return Math.max(m, Math.floor(stock / m) * m);
};

// Highest tier whose .min <= qty (SPEC: mktTierPrice). Mirrors the platform's
// server-side tier resolution so the client preview matches the PO.
export const tierPrice = (product: Product, qty: number): number => {
  let price = product.tiers[0]?.price ?? 0;
  product.tiers.forEach((t) => {
    if (qty >= t.min) price = t.price;
  });
  return price;
};

export const lineTotal = (product: Product, qty: number): number =>
  tierPrice(product, qty) * qty;

// Index of the active tier for a qty (for highlighting the tier card).
export const activeTierIndex = (product: Product, qty: number): number =>
  product.tiers.reduce((acc, t, i) => (qty >= t.min ? i : acc), 0);

export const cartSubtotal = (lines: CartLine[]): number =>
  lines.reduce((s, { product, qty }) => s + lineTotal(product, qty), 0);

// Mock-mode flat only. Freight is SERVER-OWNED — the displayed value everywhere
// comes from POST /orders/quote (useQuote → QuoteView.freightIqd).
export const FREIGHT_IQD = 1500000;

// live=true → null (freight is server-owned; a missing quote must render as
// "no freight line", NEVER a fabricated charge — resurrecting 1.5M was P0 M-01).
export const cartFreight = (lines: CartLine[], live: boolean): number | null => {
  if (!lines.length) return 0;
  return live ? null : FREIGHT_IQD;
};
